import { get, post } from '../../utils/axios'

export const listIncomeLoanSLFAPI = async (body) => {
  return await get('income/loan/slf', body)
}
export const detailIncomeLoanSLFAPI = async (body) => {
  return await get('income/loan/slf/detail', body)
}
export const importIncomeLoanSLFAPI = async (body) => {
  return await post('income/loan/slf/import', body)
}

export const deleteIncomeLoanSLFAPI = async (body) => {
  return await post('income/loan/slf/delete', body)
}
